import React, {useContext, useEffect} from 'react'
import crumbsContext from 'contexts/crumbs'
import { Link } from 'react-router-dom'
export default function BottomButton(props) {
    const {crumbs, setCrumbs} = useContext(crumbsContext)
    useEffect(() => {
        if(crumbs.length <= 1) document.location.href="/"
    }, [])
    const deleteLastCrumb = () => {
        const oldCrumbs = [...crumbs]
        oldCrumbs.pop()
        setCrumbs(oldCrumbs)
    }
    return (
        <Link 
            to={crumbs.length > 1 && crumbs[crumbs.length - 2].page}
            className='bottomButton flex center' 
            onClick={() => deleteLastCrumb()}
        >
            <img src="/back.svg" alt="" />
            &nbsp;&nbsp; RETOUR
        </Link>
    )
}
